var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vrm-warning",class:{ severe: _vm.severe }},[_c('div',{staticClass:"vrm-warning__icon sg-vrm-icon_012_alarm-32px"}),_c('div',{staticClass:"vrm-warning__text"},[_vm._t("default")],2),(_vm.onClickClose)?_c('div',{staticClass:"vrm-warning__icon--close sg-vrm-icon_055_cross-16px",on:{"click":_vm.onClickClose}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }